export default {
  strict: true,
  namespaced: true,
  state: {
    countryName: 'US',
    countryAlias: 'us',
    callingCode: '1',
    countryList: {},
    countryOnly: false,
    countryModal: false
  },
  mutations: {
    reset (state) {
      state.countryName = 'US',
      state.countryAlias = 'us',
      state.callingCode = '1',
      state.countryOnly = false,
      state.countryModal = false
    },
    setCountryName (state, countryName) {
      state.countryName = countryName
    },
    setCountryAlias (state, countryAlias) {
      state.countryAlias = countryAlias
    },
    setCallingCode (state, callingCode) {
      state.callingCode = callingCode
    },
    setCountryOnly (state, value) {
      state.countryOnly = value
    },
    setCountryList (state, value) {
      state.countryList = value
    },
    setCountryModal (state, value) { state.countryModal = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/country-code.js